import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import modalReducer from './modal';
import loadingReducer from './loading';
import userReducer from './user';
import agreeReducer from './agree';
import viewReducer from './view';
import createSagaMiddleware from '@redux-saga/core';
import { all } from '@redux-saga/core/effects';
import watchOpen from './modal.saga';

const sagaMiddleware = createSagaMiddleware();
function* rootSaga() {
  yield all([watchOpen()]);
}

const loadShowCompletedMaterials = () => {
  try {
    if (typeof window === 'undefined') return false;
    const raw = window.localStorage.getItem('addi.view.showCompletedMaterials');
    if (!raw) return false;
    return JSON.parse(raw) === true;
  } catch {
    return false;
  }
};

export const store = configureStore({
  reducer: {
    modal: modalReducer,
    loading: loadingReducer,
    user: userReducer,
    agree: agreeReducer,
    view: viewReducer,
  },
  middleware: [sagaMiddleware],
  preloadedState: {
    view: {
      showCompletedMaterials: loadShowCompletedMaterials(),
    },
  } as any,
});

sagaMiddleware.run(rootSaga);

store.subscribe(() => {
  try {
    if (typeof window === 'undefined') return;
    const { showCompletedMaterials } = store.getState().view;
    window.localStorage.setItem(
      'addi.view.showCompletedMaterials',
      JSON.stringify(showCompletedMaterials),
    );
  } catch {
    // ignore
  }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
